"use client";

import { createContext, useContext } from "react";
import type { ContextNavLayout } from "./context-nav";

export interface ContextNavContextValue {
  layout: ContextNavLayout;
  activeValue?: string;
}

export const ContextNavContext = createContext<ContextNavContextValue | null>(null);

export const useContextNav = (): ContextNavContextValue => {
  const ctx = useContext(ContextNavContext);
  if (!ctx) throw new Error("ContextNav parts must be used within <ContextNav>.");
  return ctx;
};
